module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Bold.73e05c4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Bold.woff2
// module id = 0MYr
// module chunks = 6